exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-container {\n    position: relative;\n    margin-right: 1rem;\n    margin-left: 1rem;\n    margin-bottom: 1rem;\n    min-height: calc(100vh - 4.5rem);\n}\n.full-width {\n    margin-right: -1rem;\n    margin-left: -1rem;\n}\n", ""]);

// exports
